import { render, staticRenderFns } from "./GiftComment.vue?vue&type=template&id=55c246d4&scoped=true&"
import script from "./GiftComment.vue?vue&type=script&lang=js&"
export * from "./GiftComment.vue?vue&type=script&lang=js&"
import style0 from "./GiftComment.vue?vue&type=style&index=0&id=55c246d4&lang=scss&scoped=true&"
import style1 from "./GiftComment.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c246d4",
  null
  
)

export default component.exports